import { render, staticRenderFns } from "./AlignWidget.vue?vue&type=template&id=93aa7a0e&scoped=true&"
import script from "./AlignWidget.vue?vue&type=script&lang=js&"
export * from "./AlignWidget.vue?vue&type=script&lang=js&"
import style0 from "./AlignWidget.vue?vue&type=style&index=0&id=93aa7a0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aa7a0e",
  null
  
)

export default component.exports